import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { AVAILABLE_STATUSES } from "./constants";
var compareHouse = function compareHouse(a, b) {
  return parseInt(a.label, 10) - parseInt(b.label, 10);
};
export var mapStreetSuggestionsResponse = function mapStreetSuggestionsResponse(_ref) {
  var data = _ref.data;
  return data || [];
};
export var mapHouseSuggestionsResponse = function mapHouseSuggestionsResponse(_ref2) {
  var data = _ref2.data;
  return _toConsumableArray(data || []).sort(compareHouse);
};
export var mapCheckConnectionResponse = function mapCheckConnectionResponse(_ref3) {
  var connectionState = _ref3.connectionState,
    highSpeedAvailable = _ref3.highSpeedAvailable,
    houseColor = _ref3.houseColor;
  return {
    connected: AVAILABLE_STATUSES.includes(connectionState),
    highSpeed: highSpeedAvailable,
    houseColor: houseColor
  };
};